module.exports = __webpack_public_path__ + "static/media/dark_irancell_labz_bg_login.b018a6b3.svg";